module.exports = {"210505001":"南芬街道","210505002":"铁山街道","210505003":"郭家街道","210505004":"思山岭街道","210505005":"下马塘街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210505.json
// module id = 494
// module chunks = 0